import { Link_Target } from '@wix/ricos';
export const generalLinkSettings = {
    initialLinkOptions: {
        target: Link_Target.BLANK,
        noreferrer: true,
    },
};
//# sourceMappingURL=linkSettings.js.map